import React, { useEffect, useState, useContext } from "react";
import MrfTypeForm from "../MrfTypeForm";
import { toast } from "react-toastify";
import Layout from "components/sales/layout/layout";
import { BaseUrl } from "contexts/baseUrl/baseUrl";

const CreateMrfType = ({ createMrfType, getMrfTypeDropdownData, dropdownData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);

  const [formData, setFormData] = useState({
    // MRF header
    code: "",
    close_mrf: "",
    mrf_type: "",
    contract_no_mandatory: "",
    customer_no_mandatory: "",

    // Park Capex
    park_capex_scope: "",
    park_capex_site: "",
    park_capex_txn: "",
    park_capex_post_journal: "",

    // Park Opex
    park_opex_scope: "",
    park_opex_site: "",
    park_opex_txn: "",
    park_opex_fixed_asset_creation: "",
    park_opex_gen_prod_posting: "",
    park_opex_post_journal: "",

    // Client Capex
    client_capex_scope: "",
    client_capex_site: "",
    client_capex_txn: "",
    client_capex_gen_prod_posting: "",
    client_capex_post_journal: "",

    // Client Opex
    client_opex_scope: "",
    client_opex_site: "",
    client_opex_txn: "",
    client_opex_post_journal: "",

    // JV G/L
    debit_gl_account: "",
    credit_gl_account: "",

    // Item Journal
    item_journal_gen_posting: "",

    // Material Return
    material_return: "",
    material_return_txn: "",
    material_return_gen_prod_posting: "",
    depreciation_rate: "",

    // Empty combination
    empty_scope: "",
    empty_site: "",
    empty_txn: "",

    // Transfer to bin
    faulty_bin: "",
    bin_material_status: "",

    // Tag return / Dismantle / Validations
    tag_return: "",
    dismantle: "",
    validation_type_of_site: "",
    validation_neg_sale_posted: "",
  });

  useEffect(() => {
    if (dropdownData) getMrfTypeDropdownData();
  }, []);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const normalized =
      value && typeof value === "object" && value.id !== undefined ? value.id : value;
    setFormData((prev) => ({ ...prev, [name]: normalized }));
  };

  const handleSubmit = async () => {

      if (!formData.code || !formData.mrf_type) {
        toast.error("Please fill MRF Code and MRF Type");
        return;
      }

      const payload = { ...formData };

      setIsLoading(true);
      const res = await createMrfType(payload);

      if (res.status == 0) {
        toast.success(res?.data || "MRF Type created successfully!");
        setTimeout(() => {
          window.location.href = `${baseUrl}/procurement/mrf-types`;
        }, 1000);
      } else {
        toast.error(res?.message || "Failed to create MRF Type");
      }

      setIsLoading(false);

  };

  return (
    <Layout title={"Create MRF Type"} isLoading={isLoading} isGoback={true}>
      <MrfTypeForm
        formData={formData}
        handleInputChange={handleInputChange}
        setFormData={setFormData}
        handleSubmit={handleSubmit}
        dropdownData={dropdownData}
        isLoading={isLoading}
        isEdit={false}
      />
    </Layout>
  );
};

export default CreateMrfType;